/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck
/** session操作 */
import { http } from '@/services/api/http';
import { RequestOptions } from '@/services/api/types';
import type * as model from './models';

/** session操作 inquiry的ask类型的消息 */
export async function inquiryAskPost(payload: model.IApiSessionInquiryAskReq, options?: RequestOptions) {
  const data = payload;

  const result = await http.request<model.IApiJsonResultSessionInquiryAskResp>({
    url: `/es/api/biz/session/inquiry-ask`,
    method: 'post',
    data,
    ...options,
  });

  return result.data;
}

/** session操作 inquiry卡片 */
export async function inquiryCardPost(payload: model.IApiSessionInquiryCardReq, options?: RequestOptions) {
  const data = payload;

  const result = await http.request<model.IApiJsonResultSessionInquiryCardResp>({
    url: `/es/api/biz/session/inquiry-card`,
    method: 'post',
    data,
    ...options,
  });

  return result.data;
}

/** session操作 查询洞察标签 */
export async function getInsightChipPost(
  payload: {
    messageId: string;
  },
  options?: RequestOptions
) {
  const params = payload;

  const result = await http.request<model.IApiJsonResultSubMessageDto>({
    url: `/es/api/biz/session/insight-chip`,
    method: 'post',
    params,
    ...options,
  });

  return result.data;
}

/** session操作 查询邮件内容详情 */
export async function emailExpandPost(payload: model.IApiSessionEmailExpandReq, options?: RequestOptions) {
  const data = payload;

  const result = await http.request<model.IApiJsonResultSessionEmailExpandResp>({
    url: `/es/api/pub/session/email-expand`,
    method: 'post',
    data,
    ...options,
  });

  return result.data;
}

/** session操作 查询是否需要展示邮件编辑指引 */
export async function emailGuidePost(payload: model.IApiSessionEmailGuideReq, options?: RequestOptions) {
  const data = payload;

  const result = await http.request<model.IApiJsonResultSessionEmailGuideResp>({
    url: `/es/api/pub/session/email-guide`,
    method: 'post',
    data,
    ...options,
  });

  return result.data;
}

/** session操作 标记邮件消息为已读 */
export async function emailReadPost(payload: model.IApiSessionEmailReadReq, options?: RequestOptions) {
  const data = payload;

  const result = await http.request<model.IApiJsonResultstring>({
    url: `/es/api/pub/session/email-read`,
    method: 'post',
    data,
    ...options,
  });

  return result.data;
}

/** session操作 反馈 */
export async function feedbackPost(payload: model.IApiSessionMsgFeedbackReq, options?: RequestOptions) {
  const data = payload;

  const result = await http.request<model.IApiJsonResultstring>({
    url: `/es/api/pub/session/feedback`,
    method: 'post',
    data,
    ...options,
  });

  return result.data;
}

/** session操作 通过联系人查询会话 */
export async function getSessionByContactGet(
  payload: {
    contactId: string;
  },
  options?: RequestOptions
) {
  const params = payload;

  const result = await http.request<model.IApiJsonResultSessionInfoResp>({
    url: `/es/api/pub/session/get-session-by-contact`,
    method: 'get',
    params,
    ...options,
  });

  return result.data;
}

/** session操作 globalSearchProxy */
export async function globalSearchProxyGet(options?: RequestOptions) {
  const result = await http.request<string>({
    url: `/es/api/pub/session/global-search/**`,
    method: 'get',
    ...options,
  });

  return result.data;
}

/** session操作 globalSearchProxy */
export async function globalSearchProxyPost(options?: RequestOptions) {
  const result = await http.request<string>({
    url: `/es/api/pub/session/global-search/**`,
    method: 'post',
    ...options,
  });

  return result.data;
}

/** session操作 创建聊天 */
export async function messageCreatePost(payload: model.IApiSessionMsgCreateReq, options?: RequestOptions) {
  const data = payload;

  const result = await http.request<model.IApiJsonResultCreateSessionResp>({
    url: `/es/api/pub/session/message-create`,
    method: 'post',
    data,
    ...options,
  });

  return result.data;
}

/** session操作 会话的msg列表 */
export async function messageListPost(payload: model.IApiSessionMsgListReq, options?: RequestOptions) {
  const data = payload;

  const result = await http.request<model.IApiJsonResultSessionMsgListResp>({
    url: `/es/api/pub/session/message-list`,
    method: 'post',
    data,
    ...options,
  });

  return result.data;
}

/** session操作 获取某个messageId之后的消息列表 */
export async function messageListAfterPost(payload: model.IApiSessionMsgListAfterReq, options?: RequestOptions) {
  const data = payload;

  const result = await http.request<model.IApiJsonResultSessionMsgListAfterResp>({
    url: `/es/api/pub/session/message-list-after`,
    method: 'post',
    data,
    ...options,
  });

  return result.data;
}

/** session操作 会话的msg列表 */
export async function messageListAroundPost(payload: model.IApiSessionMsgListAroundReq, options?: RequestOptions) {
  const data = payload;

  const result = await http.request<model.IApiJsonResultSessionMsgListAroundResp>({
    url: `/es/api/pub/session/message-list-around`,
    method: 'post',
    data,
    ...options,
  });

  return result.data;
}

/** session操作 修改搜索结果卡片 */
export async function modifySearchCardPost(payload: model.IApiModifySearchCardReq, options?: RequestOptions) {
  const data = payload;

  const result = await http.request<model.IApiJsonResultstring>({
    url: `/es/api/pub/session/modify-search-card`,
    method: 'post',
    data,
    ...options,
  });

  return result.data;
}

/** session操作 翻译 */
export async function productTranslatePost(payload: model.IApiSessionProductTranslate, options?: RequestOptions) {
  const data = payload;

  const result = await http.request<model.IApiJsonResultSessionProductTranslateResp>({
    url: `/es/api/pub/session/product-translate`,
    method: 'post',
    data,
    ...options,
  });

  return result.data;
}

/** session操作 更新为已读 */
export async function readPost(payload: model.IApiSessionReadReq, options?: RequestOptions) {
  const data = payload;

  const result = await http.request<model.IApiJsonResultstring>({
    url: `/es/api/pub/session/read`,
    method: 'post',
    data,
    ...options,
  });

  return result.data;
}

/** session操作 搜索卡片 */
export async function searchCardPost(payload: model.IApiSessionSearchCardReq, options?: RequestOptions) {
  const data = payload;

  const result = await http.request<model.IApiJsonResultSessionSearchCardResp>({
    url: `/es/api/pub/session/search-card`,
    method: 'post',
    data,
    ...options,
  });

  return result.data;
}

/** session操作 搜索卡片 */
export async function searchCardIdListPost(payload: model.IApiSessionSearchCardReq, options?: RequestOptions) {
  const data = payload;

  const result = await http.request<model.IApiJsonResultSessionSearchCardIdListResp>({
    url: `/es/api/pub/session/search-card-id-list`,
    method: 'post',
    data,
    ...options,
  });

  return result.data;
}

/** session操作 ai总结 */
export async function companySummaryPost(payload: model.IApiSessionCompanySummaryReq, options?: RequestOptions) {
  const data = payload;

  const result = await http.request<model.IApiJsonResultSessionCompanySummaryResp>({
    url: `/es/api/pub/session/search-card/company-summary`,
    method: 'post',
    data,
    ...options,
  });

  return result.data;
}

/** session操作 搜索卡片其他信息 */
export async function searchCardOtherPost(payload: model.IApiSessionSearchCardOtherReq, options?: RequestOptions) {
  const data = payload;

  const result = await http.request<model.IApiJsonResultSessionSearchCardOtherResp>({
    url: `/es/api/pub/session/search-card/other`,
    method: 'post',
    data,
    ...options,
  });

  return result.data;
}

/** session操作 查询搜索结果卡片状态 */
export async function searchResultCardStatusGet(
  payload: {
    messageId: number;
    sessionId: number;
    subMessageId: string;
  },
  options?: RequestOptions
) {
  const params = payload;

  const result = await http.request<model.IApiJsonResultSearchResultCardStatusResp>({
    url: `/es/api/pub/session/search-result-card/status`,
    method: 'get',
    params,
    ...options,
  });

  return result.data;
}

/** session操作 session信息 */
export async function sessionInfoPost(payload: model.IApiSessionInfoReq, options?: RequestOptions) {
  const data = payload;

  const result = await http.request<model.IApiJsonResultSessionInfoResp>({
    url: `/es/api/pub/session/session-info`,
    method: 'post',
    data,
    ...options,
  });

  return result.data;
}

/** session操作 session列表 */
export async function sessionListPost(payload: model.IApiSessionListReq, options?: RequestOptions) {
  const data = payload;

  const result = await http.request<model.IApiJsonResultSessionListResp>({
    url: `/es/api/pub/session/session-list`,
    method: 'post',
    data,
    ...options,
  });

  return result.data;
}

/** session操作 session未读统计 */
export async function sessionUnreadPost(payload: model.IApiSessionUnreadReq, options?: RequestOptions) {
  const data = payload;

  const result = await http.request<model.IApiJsonResultSessionUnreadResp>({
    url: `/es/api/pub/session/session-unread`,
    method: 'post',
    data,
    ...options,
  });

  return result.data;
}

/** session操作 创建sse连接发起对话 */
export async function startPost(payload: model.IApiSessionStartReq, options?: RequestOptions) {
  const data = payload;

  const result = await http.request<model.IApiSseEmitter>({
    url: `/es/api/pub/session/start`,
    method: 'post',
    data,
    ...options,
  });

  return result.data;
}

/** session操作 停止正在进行的会话流 */
export async function stopPost(payload: model.IApiSessionStopReq, options?: RequestOptions) {
  const data = payload;

  const result = await http.request<model.IApiJsonResultstring>({
    url: `/es/api/pub/session/stop`,
    method: 'post',
    data,
    ...options,
  });

  return result.data;
}

/** session操作 更新会话 */
export async function updatePost(payload: model.IApiSessionUpdateReq, options?: RequestOptions) {
  const data = payload;

  const result = await http.request<model.IApiJsonResultstring>({
    url: `/es/api/pub/session/update`,
    method: 'post',
    data,
    ...options,
  });

  return result.data;
}
